import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import Header from "../../stories/components/Header.js";
import LogoTableRow from "../../stories/components/LogoTableRow";
import LogoTableHead from "../../stories/components/LogoTableHead";

import {
  LogoNordlandPrimaerBokmaalNegativPdf,
  LogoNordlandPrimaerBokmaalNegativPng,
  LogoNordlandPrimaerBokmaalNegativSvg,
  LogoNordlandPrimaerBokmaalPositivPdf,
  LogoNordlandPrimaerBokmaalPositivPng,
  LogoNordlandPrimaerBokmaalPositivSvg,
  LogoNordlandPrimaerBokmaalEngelskNegativPdf,
  LogoNordlandPrimaerBokmaalEngelskNegativPng,
  LogoNordlandPrimaerBokmaalEngelskNegativSvg,
  LogoNordlandPrimaerBokmaalEngelskPositivPdf,
  LogoNordlandPrimaerBokmaalEngelskPositivPng,
  LogoNordlandPrimaerBokmaalEngelskPositivSvg,
  LogoNordlandPrimaerNynorskNegativPdf,
  LogoNordlandPrimaerNynorskNegativPng,
  LogoNordlandPrimaerNynorskNegativSvg,
  LogoNordlandPrimaerNynorskPositivPdf,
  LogoNordlandPrimaerNynorskPositivPng,
  LogoNordlandPrimaerNynorskPositivSvg,
  LogoNordlandPrimaerNynorskEngelskNegativPdf,
  LogoNordlandPrimaerNynorskEngelskNegativPng,
  LogoNordlandPrimaerNynorskEngelskNegativSvg,
  LogoNordlandPrimaerNynorskEngelskPositivPdf,
  LogoNordlandPrimaerNynorskEngelskPositivPng,
  LogoNordlandPrimaerNynorskEngelskPositivSvg,
  LogoNordlandSekundaerBokmaalNegativPdf,
  LogoNordlandSekundaerBokmaalNegativPng,
  LogoNordlandSekundaerBokmaalNegativSvg,
  LogoNordlandSekundaerBokmaalPositivPdf,
  LogoNordlandSekundaerBokmaalPositivPng,
  LogoNordlandSekundaerBokmaalPositivSvg,
  LogoNordlandSekundaerBokmaalEngelskNegativPdf,
  LogoNordlandSekundaerBokmaalEngelskNegativPng,
  LogoNordlandSekundaerBokmaalEngelskNegativSvg,
  LogoNordlandSekundaerBokmaalEngelskPositivPdf,
  LogoNordlandSekundaerBokmaalEngelskPositivPng,
  LogoNordlandSekundaerBokmaalEngelskPositivSvg,
  LogoNordlandSekundaerNynorskNegativPdf,
  LogoNordlandSekundaerNynorskNegativPng,
  LogoNordlandSekundaerNynorskNegativSvg,
  LogoNordlandSekundaerNynorskPositivPdf,
  LogoNordlandSekundaerNynorskPositivPng,
  LogoNordlandSekundaerNynorskPositivSvg,
  LogoNordlandSekundaerNynorskEngelskNegativPdf,
  LogoNordlandSekundaerNynorskEngelskNegativPng,
  LogoNordlandSekundaerNynorskEngelskNegativSvg,
  LogoNordlandSekundaerNynorskEngelskPositivPdf,
  LogoNordlandSekundaerNynorskEngelskPositivPng,
  LogoNordlandSekundaerNynorskEngelskPositivSvg,
  LogoNordlandSentrertBokmaalNegativPdf,
  LogoNordlandSentrertBokmaalNegativPng,
  LogoNordlandSentrertBokmaalNegativSvg,
  LogoNordlandSentrertBokmaalPositivPdf,
  LogoNordlandSentrertBokmaalPositivPng,
  LogoNordlandSentrertBokmaalPositivSvg,
  LogoNordlandSentrertBokmaalEngelskNegativPdf,
  LogoNordlandSentrertBokmaalEngelskNegativPng,
  LogoNordlandSentrertBokmaalEngelskNegativSvg,
  LogoNordlandSentrertBokmaalEngelskPositivPdf,
  LogoNordlandSentrertBokmaalEngelskPositivPng,
  LogoNordlandSentrertBokmaalEngelskPositivSvg,
  LogoNordlandSentrertNynorskNegativPdf,
  LogoNordlandSentrertNynorskNegativPng,
  LogoNordlandSentrertNynorskNegativSvg,
  LogoNordlandSentrertNynorskPositivPdf,
  LogoNordlandSentrertNynorskPositivPng,
  LogoNordlandSentrertNynorskPositivSvg,
  LogoNordlandSentrertNynorskEngelskNegativPdf,
  LogoNordlandSentrertNynorskEngelskNegativPng,
  LogoNordlandSentrertNynorskEngelskNegativSvg,
  LogoNordlandSentrertNynorskEngelskPositivPdf,
  LogoNordlandSentrertNynorskEngelskPositivPng,
  LogoNordlandSentrertNynorskEngelskPositivSvg,
} from "../../assets/logo/Nordland/exportNordland.js";

export default function NordlandPage() {
  return (
    <Container className="mb-6">
      <article>
        <Header
          title="Logofiler for Statsforvalteren i Nordland"
          lead="Alle logoer for Nordland i ulike variasjoner og filformater"
          breadcrumbText="Tilbake til logo"
          breadcrumbUrl="/logo"
        />
        <main>
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <p>Tekst om logovarianter og filformater...</p>
            </Col>
          </Row>
          <Row className="my-6">
            <Col>
              <h4>Primærlogo</h4>
              <Table responsive size="lg" className="table-simple">
                <LogoTableHead />
                <tbody>
                <LogoTableRow
                    logoUrl={LogoNordlandPrimaerBokmaalPositivSvg}
                    title="Primærlogo: Statsforvalteren i Nordland, bokmål"
                    text="Bokmål"
                    blackSvg={LogoNordlandPrimaerBokmaalPositivSvg}
                    blackPng={LogoNordlandPrimaerBokmaalPositivPng}
                    blackPdf={LogoNordlandPrimaerBokmaalPositivPdf}
                    whiteSvg={LogoNordlandPrimaerBokmaalNegativSvg}
                    whitePng={LogoNordlandPrimaerBokmaalNegativPng}
                    whitePdf={LogoNordlandPrimaerBokmaalNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoNordlandPrimaerBokmaalEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Nordland, bokmål + engelsk"
                    text="Bokmål + engelsk"
                    blackSvg={LogoNordlandPrimaerBokmaalEngelskPositivSvg}
                    blackPng={LogoNordlandPrimaerBokmaalEngelskPositivPng}
                    blackPdf={LogoNordlandPrimaerBokmaalEngelskPositivPdf}
                    whiteSvg={LogoNordlandPrimaerBokmaalEngelskNegativSvg}
                    whitePng={LogoNordlandPrimaerBokmaalEngelskNegativPng}
                    whitePdf={LogoNordlandPrimaerBokmaalEngelskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoNordlandPrimaerNynorskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Nordland, nynorsk"
                    text="Nynorsk"
                    blackSvg={LogoNordlandPrimaerNynorskPositivSvg}
                    blackPng={LogoNordlandPrimaerNynorskPositivPng}
                    blackPdf={LogoNordlandPrimaerNynorskPositivPdf}
                    whiteSvg={LogoNordlandPrimaerNynorskNegativSvg}
                    whitePng={LogoNordlandPrimaerNynorskNegativPng}
                    whitePdf={LogoNordlandPrimaerNynorskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoNordlandPrimaerNynorskEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Nordland, nynorsk + engelsk"
                    text="Nynorsk + engelsk"
                    blackSvg={LogoNordlandPrimaerNynorskEngelskPositivSvg}
                    blackPng={LogoNordlandPrimaerNynorskEngelskPositivPng}
                    blackPdf={LogoNordlandPrimaerNynorskEngelskPositivPdf}
                    whiteSvg={LogoNordlandPrimaerNynorskEngelskNegativSvg}
                    whitePng={LogoNordlandPrimaerNynorskEngelskNegativPng}
                    whitePdf={LogoNordlandPrimaerNynorskEngelskNegativPdf}
                  />
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row className="my-6">
            <Col>
              <h4>Sekundærlogo</h4>
              <Table responsive size="lg" className="table-simple">
                <LogoTableHead />
                <tbody>
                <LogoTableRow
                    logoUrl={LogoNordlandSekundaerBokmaalPositivSvg}
                    title="Sekundærlogo: Statsforvalteren i Nordland, bokmål"
                    text="Bokmål"
                    blackSvg={LogoNordlandSekundaerBokmaalPositivSvg}
                    blackPng={LogoNordlandSekundaerBokmaalPositivPng}
                    blackPdf={LogoNordlandSekundaerBokmaalPositivPdf}
                    whiteSvg={LogoNordlandSekundaerBokmaalNegativSvg}
                    whitePng={LogoNordlandSekundaerBokmaalNegativPng}
                    whitePdf={LogoNordlandSekundaerBokmaalNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoNordlandSekundaerBokmaalEngelskPositivSvg}
                    title="Sekundærlogo: Statsforvalteren i Nordland, bokmål + engelsk"
                    text="Bokmål + engelsk"
                    blackSvg={LogoNordlandSekundaerBokmaalEngelskPositivSvg}
                    blackPng={LogoNordlandSekundaerBokmaalEngelskPositivPng}
                    blackPdf={LogoNordlandSekundaerBokmaalEngelskPositivPdf}
                    whiteSvg={LogoNordlandSekundaerBokmaalEngelskNegativSvg}
                    whitePng={LogoNordlandSekundaerBokmaalEngelskNegativPng}
                    whitePdf={LogoNordlandSekundaerBokmaalEngelskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoNordlandSekundaerNynorskPositivSvg}
                    title="Sekundærlogo: Statsforvalteren i Nordland, nynorsk"
                    text="Nynorsk"
                    blackSvg={LogoNordlandSekundaerNynorskPositivSvg}
                    blackPng={LogoNordlandSekundaerNynorskPositivPng}
                    blackPdf={LogoNordlandSekundaerNynorskPositivPdf}
                    whiteSvg={LogoNordlandSekundaerNynorskNegativSvg}
                    whitePng={LogoNordlandSekundaerNynorskNegativPng}
                    whitePdf={LogoNordlandSekundaerNynorskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoNordlandSekundaerNynorskEngelskPositivSvg}
                    title="Sekundærlogo: Statsforvalteren i Nordland, nynorsk + engelsk"
                    text="Nynorsk + engelsk"
                    blackSvg={LogoNordlandSekundaerNynorskEngelskPositivSvg}
                    blackPng={LogoNordlandSekundaerNynorskEngelskPositivPng}
                    blackPdf={LogoNordlandSekundaerNynorskEngelskPositivPdf}
                    whiteSvg={LogoNordlandSekundaerNynorskEngelskNegativSvg}
                    whitePng={LogoNordlandSekundaerNynorskEngelskNegativPng}
                    whitePdf={LogoNordlandSekundaerNynorskEngelskNegativPdf}
                  />
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row className="my-6">
            <Col>
              <h4>Sentert logo</h4>
              <Table responsive size="lg" className="table-simple">
                <LogoTableHead />
                <tbody>
                <LogoTableRow
                    logoUrl={LogoNordlandSentrertBokmaalPositivSvg}
                    title="Sentert logo: Statsforvalteren i Nordland, bokmål"
                    text="Bokmål"
                    blackSvg={LogoNordlandSentrertBokmaalPositivSvg}
                    blackPng={LogoNordlandSentrertBokmaalPositivPng}
                    blackPdf={LogoNordlandSentrertBokmaalPositivPdf}
                    whiteSvg={LogoNordlandSentrertBokmaalNegativSvg}
                    whitePng={LogoNordlandSentrertBokmaalNegativPng}
                    whitePdf={LogoNordlandSentrertBokmaalNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoNordlandSentrertBokmaalEngelskPositivSvg}
                    title="Sentert logo: Statsforvalteren i Nordland, bokmål + engelsk"
                    text="Bokmål + engelsk"
                    blackSvg={LogoNordlandSentrertBokmaalEngelskPositivSvg}
                    blackPng={LogoNordlandSentrertBokmaalEngelskPositivPng}
                    blackPdf={LogoNordlandSentrertBokmaalEngelskPositivPdf}
                    whiteSvg={LogoNordlandSentrertBokmaalEngelskNegativSvg}
                    whitePng={LogoNordlandSentrertBokmaalEngelskNegativPng}
                    whitePdf={LogoNordlandSentrertBokmaalEngelskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoNordlandSentrertNynorskPositivSvg}
                    title="Sentert logo: Statsforvalteren i Nordland, nynorsk"
                    text="Nynorsk"
                    blackSvg={LogoNordlandSentrertNynorskPositivSvg}
                    blackPng={LogoNordlandSentrertNynorskPositivPng}
                    blackPdf={LogoNordlandSentrertNynorskPositivPdf}
                    whiteSvg={LogoNordlandSentrertNynorskNegativSvg}
                    whitePng={LogoNordlandSentrertNynorskNegativPng}
                    whitePdf={LogoNordlandSentrertNynorskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoNordlandSentrertNynorskEngelskPositivSvg}
                    title="Sentert logo: Statsforvalteren i Nordland, nynorsk + engelsk"
                    text="Nynorsk + engelsk"
                    blackSvg={LogoNordlandSentrertNynorskEngelskPositivSvg}
                    blackPng={LogoNordlandSentrertNynorskEngelskPositivPng}
                    blackPdf={LogoNordlandSentrertNynorskEngelskPositivPdf}
                    whiteSvg={LogoNordlandSentrertNynorskEngelskNegativSvg}
                    whitePng={LogoNordlandSentrertNynorskEngelskNegativPng}
                    whitePdf={LogoNordlandSentrertNynorskEngelskNegativPdf}
                  />
                </tbody>
              </Table>
            </Col>
          </Row>
        </main>
      </article>
    </Container>
  );
}
